import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';
import Accordion from '@ertelecom/ui-react/components/accordion';

export const themeForAccordion = {
    border: '#555555',
    background: '#31363b',
    color: COLORS.white,
    colorArrow: COLORS.white,
    backgroundIcon: 'transparent',
    borderIcon: COLORS.white
};

export const Questions = styled.div`
    flex-direction: column;
`;

export const QuestionTitle = styled.div`
    ${FONTS.S};
    color: ${COLORS.white};
`;

export const QuestionText = styled.div`
    ${FONTS.S};
    color: ${COLORS.white};
    & p {
        margin-bottom: 15px;
    }

    & li {
        position: relative;
        margin-bottom: 7px;
        padding-left: 15px;
    }

    & li:before {
        content: '';
        position: absolute;
        width: 5px;
        height: 5px;
        background-color: #fda609;
        top: 9px;
        left: 0;
        border-radius: 50%;
    }
`;

export const StyledAccordion = styled(Accordion)`
    margin: 5px 0;
`;
